import { Ref } from 'vue';
import {
  CAD_PLAN_ID, FieldHtmlNameUtil, HekateDisplayForm, CAM_APP_PLAN_ID_MAP,
  Trans,
} from 'www-shared';
import ExternalUtil from '../../../../ExternalUtil';
import CommonPreFilledProgressiveProfile from './CommonPreFilledProgressiveProfileDefinition';

/** Only show fields that can't be sso filled, redirect to login if the user is not logged in  */
export default class CamForFirstRoboticsProgressiveProfile extends CommonPreFilledProgressiveProfile {
  public async realtimeBranchModifications({
    formDefinition,
  }: {
    formDefinition: Ref<HekateDisplayForm>,
  }): Promise<void> {
    super.realtimeBranchModifications({ formDefinition });
    formDefinition.value.isRecaptcha = true;

    const planId = ExternalUtil.findDisplayFieldOrThrow({ formDefinition, fieldName: FieldHtmlNameUtil.planId });
    planId.val = CAD_PLAN_ID.EDU_EDUCATOR;
    const appPlanId = ExternalUtil.findDisplayFieldOrThrow({ formDefinition, fieldName: FieldHtmlNameUtil.appPlanId });
    appPlanId.val = CAM_APP_PLAN_ID_MAP.CAM.CAM_STUDIO_EDU;

    const emailField = ExternalUtil.findDisplayFieldOrThrow({ formDefinition, fieldName: FieldHtmlNameUtil.email });
    emailField.label = Trans.byValue('Educator Plan Owner Email');
    const whatIsYourExperienceField = ExternalUtil.findDisplayFieldOrThrow({ formDefinition, fieldName: FieldHtmlNameUtil.whatIsYourExperience });
    whatIsYourExperienceField.val = 'educator';

    const isProUpgradeField = ExternalUtil.findDisplayFieldOrThrow({ formDefinition, fieldName: FieldHtmlNameUtil.isProUpgrade });
    isProUpgradeField.val = 'true';
  }
}
